function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3E3558",
  fillRule: "evenodd",
  d: "M20 15.343l9.692-9.692a3 3 0 1 1 4.243 4.242l-9.692 9.693 10.106 10.106a3 3 0 1 1-4.242 4.243L20 23.828 9.893 33.935a3 3 0 0 1-4.242-4.243l10.106-10.106-9.692-9.693a3 3 0 0 1 4.243-4.242L20 15.343z"
});

var SvgClose = function SvgClose(props) {
  return React.createElement("svg", _extends({
    width: 40,
    height: 40
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/close.f3bf4e04.svg";
export { SvgClose as ReactComponent };